"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactBootstrap = require("react-bootstrap");
var Fade = ReactBootstrap.Fade;
var NotificationMessageNotifier = (function (_super) {
    __extends(NotificationMessageNotifier, _super);
    function NotificationMessageNotifier(props) {
        var _this = _super.call(this, props) || this;
        _this.messageKey = "notification/lastMessages";
        _this.handleDismiss = function (id) {
            var messages = _this.state.messages;
            var message = _.find(messages, function (msg) { return msg.id == id; });
            message.viewed = true;
            _this.updateLocalStorage(messages);
            _this.setState({
                messages: messages
            });
        };
        _this.toggleMessage = function () {
            var toggledViewStatus = !(_.find(_this.state.messages, function (msg) { return msg.viewed; }) || { viewed: false }).viewed;
            var messages = _.map(_this.state.messages, function (msg) { msg.viewed = toggledViewStatus; return msg; });
            _this.updateLocalStorage(messages);
            _this.setState({
                messages: messages
            });
        };
        _this.state = {
            messages: []
        };
        return _this;
    }
    NotificationMessageNotifier.prototype.updateViewedStatusFromLocalStorage = function (messages) {
        if (typeof (Storage) !== "undefined") {
            var localStoreMessages = (JSON.parse(localStorage.getItem(this.messageKey)) || []);
            messages = _.map(messages, function (msg) {
                var localMessage = localStoreMessages.find(function (lmsg) { return lmsg.id == msg.id; });
                if (localMessage != null) {
                    msg.viewed = localMessage.viewed;
                }
                return msg;
            });
            return messages;
        }
    };
    NotificationMessageNotifier.prototype.updateLocalStorage = function (messages) {
        if (typeof (Storage) !== "undefined") {
            var messageStatuses = _.map(messages, function (msg) { return ({ id: msg.id, viewed: msg.viewed }); });
            localStorage.setItem(this.messageKey, JSON.stringify(messageStatuses));
        }
    };
    NotificationMessageNotifier.prototype.componentDidMount = function () {
        var _this = this;
        fetch("api/navigation/notification", { credentials: 'same-origin' }).then(function (response) {
            if (response.ok) {
                response.json().then(function (result) {
                    var messages = _this.updateViewedStatusFromLocalStorage(result);
                    _this.setState({
                        messages: messages
                    });
                }).catch(function (err) { return Promise.reject(err); });
            }
            else {
                response.json().then(function (err) { return Promise.reject(err); });
            }
        }).catch(function (err) { return console.error("Unable to retrive notification message: " + err); });
    };
    NotificationMessageNotifier.prototype.render = function () {
        var _this = this;
        if (this.state.messages == null || this.state.messages.length === 0)
            return null;
        return (React.createElement("div", null,
            React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                React.createElement("li", null,
                    React.createElement("p", { className: "navbar-text pointer " },
                        React.createElement("span", { className: "glyphicon glyphicon-warning-sign state-color-started", onClick: this.toggleMessage })))),
            React.createElement("div", { className: "clear notification-alert-container" }, _.map(this.state.messages, function (message) {
                return React.createElement(NotificationMessageViewer, { key: message.id, message: message.message, viewed: message.viewed, onDismiss: function () { return _this.handleDismiss(message.id); } });
            }))));
    };
    return NotificationMessageNotifier;
}(React.Component));
exports.NotificationMessageNotifier = NotificationMessageNotifier;
var NotificationMessageViewer = (function (_super) {
    __extends(NotificationMessageViewer, _super);
    function NotificationMessageViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationMessageViewer.prototype.render = function () {
        return (React.createElement(Fade, { in: !this.props.viewed, unmountOnExit: true },
            React.createElement("div", { className: "clear" },
                React.createElement("div", { className: "alert alert-warning notification-alert" },
                    React.createElement("span", { className: "close", onClick: this.props.onDismiss }, "\u00D7"),
                    React.createElement("p", null, this.props.message)))));
    };
    ;
    return NotificationMessageViewer;
}(React.Component));
exports.NotificationMessageViewer = NotificationMessageViewer;



//////////////////
// WEBPACK FOOTER
// ./Scripts/app/navigation/NotificationMessageNotifier.tsx
// module id = 1819
// module chunks = 6